export default "__VITE_ASSET__qXoe$hH5__"